import React from 'react';
import styles from './toggle-field.scss';
import commonStyles from '../common.scss';

import Shortcuts from 'core/keyboard';
import FieldNote from '../field-note';

import { ToggleFieldProps } from 'ui/form/fields';
import { REQUIRED } from 'ui/form/constants';
import { FormField } from 'ui/form/form-field';
import { isValue } from 'ui/form/utils';

interface ToggleSwitchState {
  focus: boolean;
}

let id = 0;
export default class ToggleField extends FormField<ToggleFieldProps, ToggleSwitchState> {
  static getErrors(props: ToggleFieldProps, formData): string | false {
    const value = isValue(props.value) ? props.value : (formData || {})[props.name];
    
    return (props.required && !value) ? REQUIRED : false;
  }
  
  id = 'toggle-' + id++;
  input: HTMLInputElement;
  state = { focus: false };

  validate() {
    const internalError = ToggleField.getErrors(this.props);
    this.setState({ internalError });
    
    return !internalError;
  }

  focus = () => {
    if (this.input && !this.state.focus) this.input.focus({ preventScroll: true });
  };
  
  handleBlur = () => {
    this.setState({ focus: false });
    Shortcuts.offKey('enter', this.handleToggle);
    Shortcuts.offKey('space', this.handleToggle);
  };

  handleClick = (e: MouseEvent) => {
    // prevent checkbox from loosing focus
    e.preventDefault();
    // make sure it has focus
    this.focus();
    this.handleToggle();
  };

  handleFocus = () => {
    this.setState({ focus: true });
    Shortcuts.onKey('enter', this.handleToggle, true);
    Shortcuts.onKey('space', this.handleToggle, true);
  };

  handleToggle = () => {
    const { onChange, value } = this.props;

    if (onChange) onChange(!value);
  };

  render() {
    const {
      focus,
      internalError = false
    } = this.state;
    
    const {
      autoFocus,
      help,
      error = internalError,
      label,
      name,
      tabIndex,
      tiny,
      value
    } = this.props;

    const cl = [styles.root, commonStyles.field];
    if (value) cl.push(styles.on);
    if (focus) cl.push(styles.focus);
    if (tiny) cl.push(styles.tiny);

    return (
      <div className={cl.join(' ')} onMouseDown={this.handleClick} onClick={this.focus}>
        <div className={tiny ? styles.tinyField : styles.field}>
          <label htmlFor={this.id} className={label ? '' : styles.red}>
            {label || 'Missing label'}
          </label>
          <input
            type="checkbox"
            id={this.id}
            name={name}
            checked={value || false}
            tabIndex={tabIndex || 0}
            autoFocus={autoFocus}
            ref={ref => (this.input = ref)}
            onFocus={this.handleFocus}
            onBlur={this.handleBlur}
            readOnly
          />
          <div className={styles.track}>
            <div className={styles.thumb}>
              <div className={styles.number} />
            </div>
          </div>
        </div>

        {!tiny && <FieldNote note={help} error={error} />}
      </div>
    );
  }
}
